// extracted by mini-css-extract-plugin
module.exports = {"ComponentBodyFaqList":"ComponentBodyFaqList_ComponentBodyFaqList__VU7dD"};